import { usePostHog } from "posthog-js/react";

// Event name best practices : https://posthog.com/docs/product-analytics/best-practices
export const AnalyticsEvent = {
  // Pages
  QuoteRequestOpened: "quote_request:opened",
  SimilarPartPageViewed: "similarPart:page_viewed",
  SettingsPageViewed: "settings:page_viewed",
  // User
  UserConnected: "user:connected",
  // Onboarding
  OnboardingCompleted: "onboarding:completed",
  OnboardingSavedAndExited: "onboarding:saved_and_exited",
  OnboardingStepViewed: "onboarding:step_viewed",
  OnboardingStepBack: "onboarding:step_back",
  OnboardingAddMaterialClicked: "onboarding:add_material_clicked",
  OnboardingMaterialAdded: "onboarding:material_added",
  OnboardingMaterialListImported: "onboarding:material_list_imported",
  OnboardingAddProcessStepClicked: "onboarding:add_process_step_clicked",
  OnboardingProcessStepAdded: "onboarding:process_step_added",
  OnboardingAddDefaultProcessStepClicked: "onboarding:add_default_process_step_clicked",
  OnboardingDefaultProcessStepAdded: "onboarding:default_process_step_added",
  // Quote
  QuoteGenerated: "quote:generated",
  QuotePdfDownloaded: "quote:pdf_downloaded",
  QuoteErpExported: "quote:erp_exported",
  // Bulk actions
  BulkMaterialChanged: "batch_action:material_changed",
  BulkQuantityChanged: "batch_action:quantity_changed",
  BulkConsultationExported: "batch_action:consultation_exported",
  // File drop
  UserDropFile: "user_drop_file",
  // Search
  SimilarPartSearchStarted: "search:similar_part_search_started",
  // Prediction
  PredictionStarted: "prediction:started",
  PredictionCompleted: "prediction:completed",
  PredictionValidated: "prediction:validated",
  PredictionRerun: "prediction:rerun",
  // Quote request line
  QrlPredictionStateShown: "quote_request_line:prediction_state_shown",
  // Details panel
  DetailsPanelOpened: "details_panel:opened",
  DetailsPanelClosed: "details_panel:closed",
  DetailsPanelMachineChanged: "details_panel:machine_changed",
  DetailsPanelProcessStepEdited: "details_panel:process_step_edited",
  DetailsPanelProcessStepAdded: "details_panel:process_step_added",
  DetailsPanelProcessStepRemoved: "details_panel:process_step_removed",
  DetailsPanelProcessStepsReordered: "details_panel:process_steps_reordered",
  DetailsPanelLayoutEdited: "details_panel:layout_edited",
  DetailsPanelMaterialPriceEdited: "details_panel:material_price_edited",
  QuoteRequestLineCostDetailsClick: "quote_request_line:cost_details_click",
  // Part 2D analysis
  Part2DComplexityExpanded: "part_2d:complexity_expanded",
  Part2DComplexityCsvExported: "part_2d:complexity_csv_exported",
  // Consultation export
  ConsultationExported: "consultation:exported",
  ConsultationEmailOpened: "consultation:email_opened",
} as const;

export const useAnalytics = () => {
  const posthog = usePostHog();

  return posthog;
};
